<template>
  <UserFormPage mode="create" />
</template>

<script>
import UserFormPage from './user-form-page.vue';

export default {
  name: 'newuser',
  components: { UserFormPage },
};
</script>
